"use client";

import React from "react";
import classes from "./CategoryRedirect.module.scss";
import DownArrow from "@/assets/icons/DownArrow";

const CategoryRedirect = ({ categories }: { categories: { title: string, id: number }[] }) => {
  const handleScroll = (categoryId: number) => {
    const section = document.getElementById(`category-${categoryId}`);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className={classes["category-container"]}>
      <div className={classes["category-button-container"]}>
        {categories.map((category, index) => (
          <React.Fragment key={category.id}>
            {index > 0 && <span className={classes["separator"]}></span>}
            <button 
              onClick={() => handleScroll(category.id)} 
              className={classes["category-button"]}>
              <span className={classes["numberPrefix"]}>
                {String(index + 1).padStart(2, "0")}
              </span>
              {category.title}
              <span className={classes["arrow"]}>
                <DownArrow />
              </span>
            </button>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CategoryRedirect;
